'use client';
import { getSize, rem } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var getTypographyVariantSizes = function(config, param, size) {
    var textAlign = param.textAlign, radius = param.radius, width = param.width;
    var heights = config.heights, sizes = config.sizes;
    var computedSize = getSize({
        size: size,
        sizes: sizes
    });
    var computedHeight = getSize({
        size: size,
        sizes: heights
    });
    var marginStyles = function() {
        var gapExpression = computedHeight + " - " + computedSize;
        switch(textAlign){
            case "start":
                return {
                    marginBottom: "calc(" + gapExpression + ")"
                };
            case "center":
                return {
                    marginTop: "calc((" + gapExpression + ") / 2)",
                    marginBottom: "calc((" + gapExpression + ") / 2)"
                };
            case "end":
                return {
                    marginTop: "calc(" + gapExpression + ")"
                };
            default:
                return {};
        }
    }();
    return _extends({}, marginStyles, {
        borderRadius: radius ? rem(radius) : rem(4),
        height: textAlign ? computedSize : computedHeight,
        width: width ? width : "100%"
    });
};

export { getTypographyVariantSizes };
